<template>
  <!-- 成功案例 -->
  <div class="exampleContainer">
    <div class="exampleList" v-show="!isShowList">
      <img src="./images/icon_none.png" alt="">
      <u class="noData">暂无数据</u>
    </div>
    
    
  </div>
</template>

<script>
export default {
  name: "Example",
  props:[],
  data(){
    return {
      // 弹框
      darenID:'',
      visible: false,
      // 分页
      currentPage: 1,
      //达人列表
      isShowList:false,
      pageSuccessExample:[],
      pageSuccessExampleItem:[]
    }
  },
  computed:{
    
  },
  methods:{

  },
  components:{
  
  },
  watch:{
    
  },
  created(){
    
  },
  mounted() {
    
  }
}
</script>

<style scoped>
  .exampleContainer{
    width: 864px;
    padding: 0;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .exampleContainer .exampleList{
    width: 100%;
  }
  .exampleContainer .exampleList .noData{
    display: block;
    text-align: center;
    margin: 20px auto;
    color: #A1A1A1;
    padding-bottom: 30px;
  }
  .exampleContainer .exampleList img{
    display: block;
    margin: auto;
    padding-top: 30px;
  }
  .exampleContainer .exampleList .listItem{
    width: 100%;
    height: 94px;
    line-height: 94px;
    cursor: pointer;
  }
  .exampleContainer .exampleList .hr{
    width: 804px;
    height: 1px;
    border-bottom: 1px solid #F0F0F0;
    margin-left: 30px;
    box-sizing: border-box;
  }
  .exampleContainer .exampleList .listItem:hover{
    background: #FBFBFB;
  }
  .exampleContainer .exampleList .listItem:hover .marketingData{
    background: #FF5C00;
    border-color: #FF5C00;
    color: #fff;
  }
  .listItem .title {
    float: left;
    width: 247px;
    margin-left: 30px;
    margin-top: 28px;
    margin-right: 48px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .listItem .creatTime{
    float: left;
    margin-right: 30px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .listItem .creatTime:nth-of-type(2){
    margin-right: 0;
  }
  .listItem .price{
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #FF5C00;
  }
  .listItem .priceInfo{
    float: left;
    width: 18px;
    height: 20px;
    margin-top: 36px;
    margin-left: 80px;
    background: url("./images/icon_price.png") no-repeat center;
    background-size: contain;
  }
  .listItem .marketingData{
    float: right;
    width: 88px;
    height: 34px;
    margin-top: 30px;
    margin-right: 30px;
    background: #FFFFFF;
    border: 1px solid #F0F0F0;
    border-radius: 4px;
    line-height: 34px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
    text-align: center;
  }
  .listItem .el-button:focus, .listItem .el-button:hover{
    color:transparent;
    border-color:transparent;
    background-color:transparent;
  }
  .listItem .el-button{
    border-color: transparent;
    padding: 0;
  }
  .priceHover{
    width: 210px;
    height: 184px;
    padding: 20px;
    box-sizing: border-box;
  }
  .priceHover .priceItem{
    width: 100%;
    height: 20px;
    margin-bottom: 16px;
  }
  .priceHover .hr{
    margin-bottom: 16px;
  }
  .priceHover .priceItem span{
    float: left;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .priceHover .priceItem i{
    float: right;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #333333;
    text-align: right;
  }
  .pages {
    width: 100%;
    height: 75px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    box-sizing: border-box;
  }
  .pages .el-pagination {
    padding: 2px 0;
  }

  .pages .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #FF5C00;
    background: #FFF2EB;
  }

  .pages .el-pagination.is-background .el-pager li:not(.disabled).active {
    color: #FF5C00;
    background: #FFF2EB;
  }
  .pages>>>.el-input__inner:focus{
    border-color:rgb(250, 159, 109);
  }
  .pages>>>.el-icon{
    text-align: center;
  }
</style>